import { ResetPasswordRequestFields } from 'components/core-v2/organisms/forms/reset-password-request'
import { RefObject, useState } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

import {
  useGetUsermanagerRecaptchaDisabledQuery,
  usePostUsermanagerForgotPasswordMutation
} from '../../../api'

interface onSubmitProps extends ResetPasswordRequestFields {
  recaptchaRef: RefObject<unknown>
}

export const useResetPasswordRequest = () => {
  const { data: recaptchaDisabledResponse } = useGetUsermanagerRecaptchaDisabledQuery()
  const [postResetPassword, { error, isError, isLoading: isPostResetPasswordLoading }] =
    usePostUsermanagerForgotPasswordMutation()

  const isRecaptchaDisabled = Boolean(recaptchaDisabledResponse?.disabled)

  const [isRecaptchaLoading, setIsRecaptchaLoading] = useState(false)

  const { executeRecaptcha } = useGoogleReCaptcha()

  const submitResetPassword = async ({ email }: onSubmitProps) => {
    if (isRecaptchaDisabled) {
      const resetResponse = await postResetPassword({
        apiForgotPassword: {
          remoteIP: null,
          recaptchaResponse: null,
          email
        }
      })

      return resetResponse
    }

    setIsRecaptchaLoading(true)

    const token = await executeRecaptcha('reset')

    const resetResponse = await postResetPassword({
      apiForgotPassword: {
        remoteIP: null,
        recaptchaResponse: token,
        email
      }
    })

    setIsRecaptchaLoading(false)
    return resetResponse
  }

  return {
    isLoading: isRecaptchaLoading || isPostResetPasswordLoading,
    submitResetPassword,
    error,
    isError
  }
}
